import React, { Component } from "react";
import NumberFormat from "react-number-format";

class AbbreviateForecastUnit extends Component {
  render() {
    const type = this.props.type || "text";
    const value = this.props.value;

    return (
      <NumberFormat value={value} displayType={type} thousandSeparator="," />
    );
  }
}

export default AbbreviateForecastUnit;



// WEBPACK FOOTER //
// ./src/components/ui-building-blocks/numbers/AbbreviateForecastUnit.js